<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="meta.width"
    :height="meta.height"
    :viewBox="meta.viewbox"
  >
    <svg:style type="text/css">
      {{ style }}
    </svg:style>
    <path
      v-for="(path, i) in paths"
      :key="`${getRandomNumber(i)}`"
      :fill="(fills && fills[i]) || path.fill"
      :d="path.d"
      :class="path.class"
    />
    <polyline
      v-for="(polyline, i) in polylines"
      :key="`${getRandomNumber(i)}`"
      :class="polyline.class"
      :points="polyline.points"
    />
  </svg>
</template>

<script>
import icons from "@/icons";

export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      required: true,
    },
    fills: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    icon() {
      if (!icons[this.name]) {
        throw new TypeError("[Icon.vue] Unknown icon name: ", this.name);
      }

      return icons[this.name];
    },
    meta() {
      return this.icon.meta;
    },
    paths() {
      return this.icon.paths;
    },
    polylines() {
      return this.icon.polylines;
    },
    style() {
      return this.icon.style;
    },
  },
  methods: {
    // Hacky solution to prevent "duplicate key" warnings for reaction icons
    getRandomNumber(i) {
      return Math.floor(Math.random() * 1024 + i);
    },
  },
};
</script>
